import request from "@/axios";

/**分页查询数据 */
/** 媒资库分页查询接口 */
export const getMediaData = params => {
  return request({
    url: "/lebo-mediaasset/mediaasset/manage/page",
    method: "get",
    params
  });
};

/** 查看媒资详情接口 */
export const getMediaDetail = id => {
  return request({
    url: `/lebo-mediaasset/mediaasset/manage/aggregation/${id}`,
    method: "GET"
  });
};

/** 更新媒资信息接口 */
export const updateMedia = data => {
  return request({
    url: "/lebo-mediaasset/mediaasset/manage/update",
    method: "put",
    data
  });
};

/** 获取关联媒资信息接口 */
export const getCorrelateMedia = id => {
  return request({
    url: `
/lebo-mediaasset/mediaasset/manage/association/${id}`,
    method: "get"
  });
};

/** 设置关联媒资信息接口 */
export const setCorrelateMedia = data => {
  return request({
    url: "/lebo-mediaasset/mediaasset/manage/association",
    method: "post",
    data
  });
};

/** 上架媒资 */
export const takeOnMedia = id => {
  return request({
    url: `/lebo-mediaasset/mediaasset/manage/put-on/${id}`,
    method: "post"
  });
};

/** 下架媒资 */
export const takeOffMedia = id => {
  return request({
    url: `/lebo-mediaasset/mediaasset/manage/take-off/${id}`,
    method: "post"
  });
};

/** 通过爬虫新增媒资 */
export const addMediaBySpider = data => {
  return request({
    url: "/lebo-mediaasset/mediaasset/manage/add-by-crawl",
    method: "post",
    data
  });
};

/** 通过url查询媒资 */
export const getMediaByUrl = params => {
  return request({
    url: "/lebo-mediaasset/mediaasset/manage/url",
    method: "get",
    params
  });
};

/** 上传图片 */
export const uploadImg = data => {
  return request({
    url: "/lebo-resource/oss/endpoint/put-file?code=lebotob",
    method: "post",
    data
  });
};
/** 查询年份 */
export const getYear = () => {
  return request({
    url: "/lebo-system/dict-biz/list",
    method: "get",
    params: {
      code: "MEDIA_YEAR_QO"
    }
  });
};

/** 分页查询主媒资 */
export const getPrimaryMedia = params => {
  return request({
    url: "/lebo-rabbit/popular-cast/primary-media/page",
    method: "get",
    params
  });
};
